'use strict';

var chunkWAUX3N2G_js = require('./chunk-WAUX3N2G.js');
var chunk32OAM7MJ_js = require('./chunk-32OAM7MJ.js');
var jsxRuntime = require('react/jsx-runtime');

var d=({width:o,height:i,borderRadius:s="0px",color:l="lightGrey",...n})=>{let a={width:o,height:i,borderRadius:s};return jsxRuntime.jsx("div",{className:chunkWAUX3N2G_js.a(`${chunk32OAM7MJ_js.a}-skeleton`),...n,children:jsxRuntime.jsx("div",{className:`skeleton ${l}`,style:a})})},m=d;

exports.a = m;
//# sourceMappingURL=out.js.map
//# sourceMappingURL=chunk-ZD6U5IJT.js.map